import axios from 'axios';
const instance = axios.create({
    baseURL: `https://api.handshook.app/`,
});
export default instance;